<template>
  <div>
    <!-- 普通导航 -->
    <van-nav-bar :fixed="true" v-if="!hasRightContent"
      z-index="10"
      left-arrow
      :title="navTitle"
      @click-left="goPath(navPath)">
    </van-nav-bar>
    <van-nav-bar :fixed="true" v-else
      z-index="10"
      left-arrow
      :title="navTitle"
      @click-left="goPath(navPath)"
      @click-right="rightHandler">
      <template #right>
        <!-- 右侧自定义内容 -->
        <slot name="navRightContent"></slot>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
    components: {
    },
    props: {
      hasRightContent: {
        type: Boolean,
        default: false
      },
      rightHandler: {
        type: Function,
        default: null
      },
      navTitle: {
        type: String,
        default: ''
      },
      navPath: {
        type: String,
        default: '/'
      },
    },
    data() {
        return {}
    },
    methods: {
      goPath(path) {

        if (path){
            this.$router.push(path);
        } else {
            this.$router.go(-1);
        }


      },
    }
}
</script>

